module.exports = __webpack_public_path__ + "/images/price-tend-up.c1f40a9.svg";